import { Skeleton } from 'antd'

import { PropsWithChildren } from 'react'

import type { SkeletonProps } from 'antd'

type Props = {
  loading?: boolean
  wrapperClassName?: string
} & PropsWithChildren &
  SkeletonProps

export const SkeletonWrapper = ({
  loading,
  wrapperClassName,
  children,
  ...props
}: Props) => {
  if (loading) return <Skeleton active {...props} />

  return <div className={wrapperClassName}>{children}</div>
}
